import classnames from 'classnames'
import PropTypes from 'prop-types'

import DownloadIcon from './DownloadIcon'

import './downloadLink.scss'

const DownloadLink = ({className, onClick}) => (
  <a className={classnames('download-link', className)} onClick={onClick}>
    <div className='action-link-icon-wrapper'>
      <DownloadIcon className='action-link-icon' />
    </div>
    <span> Preview / Download</span>
  </a>
)

DownloadLink.propTypes = {onClick: PropTypes.func}

export default DownloadLink
